const removeHTMLTags = (rawText = "") => {
  return rawText?.replace(/<\/?[^>]+(>|$)/g, "");
};

export default removeHTMLTags;
